import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { extractIp } from "../redux/utils";
import { customToast } from "../components/common/customToast";

/**
 * Şube sayfalarında ortak koruma: şubeye ulaşılamıyorsa ya da lisansı pasifse
 * kullanıcıyı şube listesine döndürür ve bir uyarı gösterir.
 * Özet bilgisi henüz yüklenmemişse karar vermez.
 */
export default function useBranchGuard() {
  const { t } = useTranslation();
  const branchIp = useParams().id;
  const navigate = useNavigate();
  const { branches } = useSelector((state) => state.branches);
  const summary = useSelector((state) => state.reports.reportSummary);

  useEffect(() => {
    if (!summary || !branches || branches.length === 0) return;
    const branch = branches.find(
      (item) => extractIp(item.ipAddress) === String(branchIp)
    );
    if (!branch) return;
    const state = summary[branch.ipAddress];
    if (!state || state.loading) return;
    if (!state.success || branch.status !== 1) {
      navigate("/");
      customToast(t("branches.inActive", { branch: "" }));
    }
  }, [branches, summary, branchIp, navigate, t]);
}
